import { Button, CardMedia, Grid, Typography } from '@mui/material'
import { Box, Container, keyframes } from '@mui/system'
import React from 'react'
import Timeline from './Timeline'
import { Formik, Form, Field } from "formik";
import { TextField as MuiTextField } from 'formik-mui';
import * as Yup from 'yup';
import { alertMsg } from '../../utils/basicUtils';
import { useState } from 'react';
import { axiosFetch } from '../../utils/apiUtils';
import { Link, useNavigate } from 'react-router-dom';
import { BRAND_NAME } from '../../constants';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { useTheme } from '@emotion/react'
import PasswordStrength from '../../components/PasswordStrength';

const pageload = keyframes`
	from {
		opacity: 0;
		transform: translateX(-100px);
   	}
   to {
		opacity: 1;
		transform: translate(0px);
   }
`

const Signup = () => {
	const theme = useTheme()
	const navigate = useNavigate();
	const [isShowPassword, setIsShowPassword] = useState(false)


	// function handlePasswordStrength(password) {
	// 	let strength = 1
	// 	const numOrSymbol = (/\d/.test(password) || /[_!@#$&*]/.test(password))
	// 	const upperCase = /[A-Z]/.test(password)
	// 	const lowerCase = /[a-z]/.test(password)

	// 	if (password.length <= 3) {
	// 		strength = 1
	// 	} if (password.length > 6 && lowerCase && (numOrSymbol || upperCase) || upperCase && (numOrSymbol || lowerCase)) {
	// 		strength = 2
	// 	} if (password.length > 8 && lowerCase && upperCase && numOrSymbol) {
	// 		strength = 3
	// 	}
	// 	return strength
	// }
	return (

		<Box sx={{ height: { xs: "100%", md: '100vh' } }} >
			<Grid container>
				<Grid item xs={12} lg={4} xl={5}>
					<Container maxWidth="sm" sx={{ mt: 5, maxHeight: '100vh' }} >
						<Link to="https://primeophoto.com" style={{ textDecoration: "none" }}>
							<Box sx={{ display: "flex", alignItems: "center", justifyContent: 'center' }}>
								<Box >
									<CardMedia component="img" title="" sx={{ maxWidth: { xs: "60px", sm: "80px" } }} image={process.env.PUBLIC_URL + "/assets/logo.png"} />
								</Box>
								<Box sx={{ marginLeft: "10px", overflow: "hidden", }}>
									<Typography fontWeight={400} fontSize={30} sx={{ animation: `${pageload} 1200ms ease 500ms backwards`, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>{BRAND_NAME}</Typography>
								</Box>
							</Box>
						</Link>
						<Box sx={{ mt: { xs: 6, xl: 10 } }}>
							<Box textAlign={"center"}>
								<Typography fontWeight={400} sx={{ fontSize: { xs: "20px", md: "22px", xl: "25px" }, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Sign up to your account</Typography>
							</Box>
							<Box sx={{ mt: 4, width: { xs: "100%", sm: "80%", md: "95%", xl: "90%", }, marginLeft: "auto", marginRight: "auto" }}>
								<Formik
									initialValues={{
										email: '',
										first_name: '',
										last_name: '',
										username: '',
										password: '',
									}}
									validationSchema={
										Yup.object({
											first_name: Yup.string()
												.required('Name is required')
												.matches(/^[a-zA-Z\s]+$/, 'Name cannot contain special character and numbers')
												.min(3, 'Name must be at least 3 characters')
												.max(50, 'Name cannot exceed 50 characters'),
											email: Yup.string()
												.email('Invalid email address')
												.required('Email is required'),
											password: Yup.string()
												.required('Password is required')
												.min(8, "Must be at least 8 characters")
												.max(100, "Password maximum 100 characters only Allowed")
											// .matches(/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,100}$/, 'Password can contain atleast 1 number and 1 special character'),
										})
									}
									onSubmit={async (values, { setSubmitting }) => {
										try {
											const response = await axiosFetch.post("accounts/signup/", values)
											alertMsg(response.data.message, 'success')
											navigate('/accounts/signin')
										}
										catch (error) {
											console.error(error)
										}
										setSubmitting(false);
									}}
								>
									{
										({ isSubmitting, submitForm, values }) => {
											return (
												<Form>
													<Box>
														<Box sx={{ mt: 4, }}>
															<Field
																component={MuiTextField}
																name="first_name"
																label="Name"
																inputProps={{ maxLength: 35 }}
																fullWidth
															/>
														</Box>
														<Box sx={{ mt: 4, }}>
															<Field
																component={MuiTextField}
																name="email"
																label="Email"
																type="email"
																fullWidth
															/>
														</Box>
														<Box sx={{ mt: 4, position: "relative" }}>
															<Field
																component={MuiTextField}
																name="password"
																label="Choose password"
																type={!isShowPassword ? "password" : "text"}
																// inputProps={{ maxLength: 12 }}
																fullWidth
																InputProps={{
																	endAdornment:
																		<InputAdornment position="end">
																			<IconButton
																				onClick={() => { setIsShowPassword(prev => !prev) }}
																				edge="end"
																			>
																				{!isShowPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
																			</IconButton>
																		</InputAdornment>
																}}
															/>
															<PasswordStrength password={values.password} sx={{ position: "absolute", bottom: { xs: -5, sm: -3, lg: -10 }, left: 35, display: "flex", alignItems: "center", gap: .5, justifyContent: "end", right: 2 }} ></PasswordStrength>
															{/* <Box sx={{ position: "absolute", bottom: { xs: -5, sm: -3, lg: -10 }, left: 35, display: "flex", alignItems: "center", gap: .5, justifyContent: "end", right: 2 }}>
																<Box sx={{ height: 3, borderRadius: 10, width: 20, backgroundColor: values.password !== "" && handlePasswordStrength(values.password) >= 1 ? "#ff2f2f" : "#d3d3d3" }} />
																<Box sx={{ height: 3, borderRadius: 10, width: 20, backgroundColor: handlePasswordStrength(values.password) >= 2 ? "#edae3b" : "#d3d3d3" }} />
																<Box sx={{ height: 3, borderRadius: 10, width: 20, backgroundColor: handlePasswordStrength(values.password) >= 3 ? "#12a312" : "#d3d3d3" }} />
															</Box> */}
														</Box>
													</Box>

													<Box sx={{ mt: 4, textAlign: "center" }}>
														<Button
															size='large'
															variant="outlined"
															disabled={isSubmitting}
															onClick={(e) => e.detail === 1 && submitForm()}
														>Sign up</Button>
													</Box>
												</Form>
											)
										}
									}
								</Formik>
								{/* <Box sx={{ mt: 5, borderBottom: "1px solid #c4c4c4" }}></Box>
                <Box sx={{ mt: 5, textAlign: "center" }}>
                  <Box sx={{ border: "1px solid #c4c4c4", padding: "15px", borderRadius: "4px" }}>
                    <Box>
                      <Grid container sx={{ alignItems: "center" }}>
                        <Grid xs={1}>
                          <Box>
                            <img style={{ width: "30px" }} src="https://cdn-icons-png.flaticon.com/512/281/281764.png" alt="" />
                          </Box>
                        </Grid>
                        <Grid xs={11}>
                          <Box>
                            <Typography>Login with Google</Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </Box> */}
								<Box sx={{ my: 4, textAlign: "center", pb: { xs: 2, sm: 0 } }}>
									<Typography sx={{ marginRight: "10px" }} fontSize={15} variant='span'>Already have an account?</Typography>
									<Link to={"/accounts/signin"} fontSize={15} color={"primary"} style={{ textDecoration: "none" }}>Sign in</Link>
								</Box>
							</Box>
						</Box>
					</Container>
				</Grid>
				<Grid item lg={8} xl={7} sx={{ display: { xs: "none", md: "block" } }}>
					<Box sx={{ maxHeight: { xs: "100%", lg: "100vh" }, height: { xs: "100%", lg: "100vh" }, overflow: 'auto' }} className='overflow-scroll' bgcolor="background.primary">
						<Box>
							<Timeline></Timeline>
						</Box>
					</Box>
				</Grid>
			</Grid>
		</Box>
	)
}

export default Signup
